export const realtorData = {
  email: 'BASCURPROPIEDADES@UNNE.CL',
  phone:'995494606'
};
